// How an engine call failed, for the words the user sees (api/failure.ts
// `engine_bug`, `engine_slow`): the raw message is for Details only.

/**
 * - `bug`: the engine failed working it out: a panic or trap (the worker
 *   was replaced, fatal.ts) or an error it reported (input it could not
 *   read).
 * - `slow`: the call ran past its time budget (the worker was replaced).
 */
export type EngineFailureKind = 'bug' | 'slow';

/** An engine call that failed; `message` is the engine's own words. */
export class EngineError extends Error {
  override name = 'EngineError';

  constructor(
    /** The `EngineApi` method called. */
    readonly method: string,
    readonly kind: EngineFailureKind,
    message: string,
  ) {
    super(message);
  }
}
